import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiAlertCircle } from 'react-icons/fi';
import spinnerGif from '../../assets/spinner-tv.gif';
import './PlaybackStatusOverlay.css';

export type PlaybackOverlayStatus = 'connecting' | 'buffering' | 'reconnecting' | 'error';

interface PlaybackStatusOverlayProps {
  status: PlaybackOverlayStatus;
  message?: string;
}

export const PlaybackStatusOverlay: React.FC<PlaybackStatusOverlayProps> = ({ status, message }) => {
  const { t } = useTranslation();
  const label = message || t(`playback.${status}`);

  return (
    <div className="playback-status" role="status" aria-live="polite">
      <div className={`playback-status__panel playback-status__panel--${status}`}>
        {status === 'error' ? (
          <FiAlertCircle className="playback-status__icon playback-status__icon--error" />
        ) : (
          <img className="playback-status__spinner" src={spinnerGif} alt="" />
        )}
        <span className="playback-status__text">{label}</span>
      </div>
    </div>
  );
};
